// extracted by mini-css-extract-plugin
module.exports = {"authorAvatar":"_3fh83"};